module.exports = __webpack_public_path__ + "media/images/icons/outlined/plus-square-1c5917793b3e06133b0fecfdc37ce4a3.svg";